import type { OrganizationExchangeRatesQuery } from 'types/graphql';

export const QUERY_EXCHANGE_RATES = gql`
  query OrganizationExchangeRatesQuery {
    exchangeRates {
      rates
    }
  }
`;

type ExchangeRateSheet = NonNullable<OrganizationExchangeRatesQuery['exchangeRates']>['rates'];

/** One entry of the JSON rate sheet; the server publishes `Record<currency, number>`. */
export type ExchangeRateEntry = ExchangeRateSheet;

/** `rates[currency]`: a JSON object's entry, `undefined` for anything else (as an untyped read gave). */
export const exchangeRateFor = (
  rates: ExchangeRateSheet | undefined,
  currency: string
): ExchangeRateEntry | undefined =>
  rates !== null && typeof rates === 'object' && !Array.isArray(rates) ? rates[currency] : undefined;
